import { useEffect, useState } from 'react';
import { formatCurrency} from 'utils/utils';
import { Button } from '../Button';
import Loader from 'components/Loader';
import RadioButton from '../RadioButton';
import TextBox from '../TextBox';
import ShoppingCartService from '../services/shopping-cart.service';
import { useErrorBoundary } from 'basket/ErrorBoundary';
import { SupplyOwnFabric } from '../SupplyOwnFabric';
import ProductQtyInput from 'components/ProductQtyInput';
import { OtherFabricSelector } from '../OtherFabricSelector';
import InformationOverlay from "../InformationOverlay";
import useInfoIcons from 'hooks/useInfoIcons';
import UnitConverter from 'components/UnitConverter';
import NumberInput from '../NumberInput';
import Checkbox from '../Checkbox';

export function BasketEditRollerBlindsItem(props) {
    const { item, updateFabricItem, close } = props;
    const handleError = useErrorBoundary();
    const [price, setPrice] = useState(item.price);
    const [metres, setMetres] = useState(item.fabric.fabricMetres.toFixed(1) + 'm');
    const convertToBoolean = (value) => value == "1" || value == 1 ? true : (value == "0" || value == 0? false : value);
    const [fabricData, setFabricData] = useState({
        width: item.fabric.width,
        height: item.fabric.height,
        installationHeight: item.fabric.installationHeight,
        fabricBacking: item.fabric.fabricBacking,
        fkChainColourId: item.fabric.fkChainColourId,
        fkMotorisationComponentId: item.fabric.fkMotorisationComponentId,
        backingColour: item.fabric.backingColour,
        standardOrReverse: item.fabric.standardOrReverseRoll,
        cassetteId: item.fabric.fkCassetteId,
        bracketId: item.fabric.fkBracketId,
        widthMeasurementsId: item.fabric.fkWidthMeasurementId,
        leftOrRightCord: item.fabric.leftOrRightCord,
        motorised: item.fabric.motorised,
        customisationRequests: item.fabric.customisationRequests,
        windowLocation: item.fabric.windowLocation,
        fabricId: item.fabricId,
        quantity: item.quantity,
        supplyOwnFabricNameOrDescription: item.supplyOwnFabricNameOrDescription,
        FabricRollWidth: item.supplyOwnFabricRollWidth,
        VerticalPatternRepeat: item.supplyOwnFabricPatternRepeat
    });

    const [measurementsChecked, setMeasurementsChecked] = useState(false)
    const [showMeasurementsCheckError, setShowMeasurementsCheckError] = useState(false)

    const [loading, setLoading] = useState(false);

    const [itemTitle, setItemTitle] = useState(`${item.fabric.fabricName} in ${item.colour || ''} Fabric by ${item.fabric.supplier.name || ''}`);
    const title = () => item.supplyOwnFabric ? 'Edit Roller Blinds in Supply Your Own Fabric' : `Edit Roller Blinds - ${itemTitle}`;

    const [fabricBackings, setFabricBackings] = useState([]);
    const [chainColours, setChainColours] = useState([]);
    const [controlUnits, setControlUnits] = useState([]);
    const [brackets, setBrackets] = useState([]);
    const [recessedCassette, setRecessedCassette] = useState([])
    const [actualCassette, setActualCassette] = useState([])
    const [widthMeasurements, setWidthMeasurements] = useState([]);
    
    const [errors, setErrors] = useState({});
    const [isSubmitDisabled, setSubmitDisabled] = useState(false);
    
    const [fabrics, setFabrics] = useState([])
    const [totalFabricsCount, setTotalFabricsCount] = useState(0)
    const [selectedFabric, setSelectedFabric] = useState(fabricData.fabricId)

    const infoIcons = useInfoIcons(item.productType);

    const fetchOptions = async () => {
        const optionsResponse = await ShoppingCartService.create('options/7', {})
            .catch(error => { handleError('Could not load item details. Please contact administrator'); });
        
        if (optionsResponse){                    
            const { fabricBackings, chainColours, controlUnits } = optionsResponse;        
            setFabricBackings(fabricBackings);
            setChainColours(chainColours);
            setControlUnits(controlUnits);
        }

        await ShoppingCartService.get('cassette?recessed=true').then(setRecessedCassette)
        await ShoppingCartService.get('cassette?recessed=false').then(setActualCassette)

        const bracketsResponse = await ShoppingCartService.get('brackets')
        setBrackets(bracketsResponse)

        const widthMeasurementsResponse = await ShoppingCartService.get('width-measurements')
        setWidthMeasurements(widthMeasurementsResponse)
    };

    const handleQuantityChange = (value) => handleInputChange({target: { name: 'quantity', value: value }})

    const handleInputChange = (e) => {        
        const { name, value } = e.target;
        const updatedData = { ...fabricData, [name]: value };
        setFabricData(updatedData);
    };
    
    const createItem = () => {
        const model = {
            ...item,
            fabricId: selectedFabric,
            quantity: fabricData.quantity,
            fabric: { 
                ...fabricData,
                fabricId: selectedFabric,
                backingColour: convertToBoolean(fabricData.backingColour),
                leftOrRightCord: convertToBoolean(fabricData.leftOrRightCord),
                motorised: convertToBoolean(fabricData.motorised),
                fabricBacking: parseInt(fabricData.fabricBacking),
                fkChainColourId: parseInt(fabricData.fkChainColourId),
                fkMotorisationComponentId: parseInt(fabricData.fkMotorisationComponentId),
                standardOrReverseRoll: convertToBoolean(fabricData.standardOrReverse),
                fkCassetteId: parseInt(fabricData.cassetteId),
                fkBracketId: parseInt(fabricData.bracketId),
                fkWidthMeasurementId: parseInt(fabricData.widthMeasurementsId)
            },
            supplyOwnFabricNameOrDescription: fabricData.supplyOwnFabricNameOrDescription,
            supplyOwnFabricPatternRepeat: fabricData.VerticalPatternRepeat,
            supplyOwnFabricRollWidth: fabricData.FabricRollWidth
        };

        return model;
    };

    const getConvertedFabricData = (data) => {
        return {
            ...data,
            unitOfMeasurement: convertToBoolean(data.unitOfMeasurement),
            fabricBacking: parseInt(data.fabricBacking),
            fkChainColourId: parseInt(data.fkChainColourId),
            fkMotorisationComponentId: parseInt(data.fkMotorisationComponentId),
            backingColour: convertToBoolean(data.backingColour),
            cassette: convertToBoolean(data.cassette),
            recessed: convertToBoolean(data.recessed),
            leftOrRightCord: convertToBoolean(data.leftOrRightCord),
            motorised: convertToBoolean(data.motorised),
            standardOrReverse: convertToBoolean(data.standardOrReverse)
        };
    };

    const handlerMeasurementCheck = () => {
        setMeasurementsChecked(!measurementsChecked)
        setShowMeasurementsCheckError(false)
    }

    const handleUpdate = () => {
        if (!measurementsChecked) {
            setShowMeasurementsCheckError(true)
            return
        }

        if (!fabricData.installationHeight && !fabricData.motorised) {
            setErrors(prev => ({
                ...prev,
                InstallationHeight: 'The installation height must be greater than the Length of the roller blind'
            }));
            return;
        }

        if (fabricData.widthMeasurementsId == '1' // is recessed
            && !(recessedCassette.find(x => x.id === Number(fabricData.cassetteId)))) // not listed for recessed
        {
            setErrors({
                ...errors,
                Cassette: 'Please choose the cassette'
            });
            return;
        }
        else if (fabricData.widthMeasurementsId == '2' // is actual
            && !(actualCassette.find(x => x.id === Number(fabricData.cassetteId)))) // not listed for actual
        {
            setErrors({
                ...errors,
                Cassette: 'Please choose the cassette'
            });
            return;
        }

        setLoading(true);
        updateFabricItem(createItem());
        setLoading(false);
    };

    const updatePrice = async () => {
        const item = createItem()
                        
        setErrors([])
        
        if (item.supplyOwnFabric) {
            const isValidResponse = await fetch('/api/product/supply-own-fabric/validate', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    Description: item.supplyOwnFabricNameOrDescription,
                    VerticalPatternRepeat: Number(item.supplyOwnFabricPatternRepeat),
                    FabricRollWidth: Number(item.supplyOwnFabricRollWidth)
                })
            })
            
            if (isValidResponse.status !== 200) {
                const json = await isValidResponse.json();
                
                const lowercasedErrors = Object.entries(json).reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});

                setErrors(prev => ({
                    ...prev,
                    ...lowercasedErrors
                }));
            }
        }

        const result = await ShoppingCartService.create('price', createItem())
            .catch(_ => { handleError('Could not load item price. Please contact administrator'); });

        setPrice(result.price);
        setMetres(result.fabricMetres.toFixed(1) + 'm');
    }

    const loadFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + fabricData.fabricId)
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    const loadAllFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + fabricData.fabricId + '&showAll=true')
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    const validatePrice = async (item, callback) => {
        fetch('/api/product/roller-blinds/validate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(item)
        })
        .then(response => {
            setErrors([]) // clear errors
            if (!response.ok) {
                return response.json().then(err => { throw err });
            }
            return response.json();
        })
        .then(() => {
            callback(item);
        })
        .catch(jsonResponse => {
            const lowercasedErrors = Object.entries(jsonResponse).reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {});

            setErrors(prevErrors => ({
                ...prevErrors,
                ...lowercasedErrors
            }));
        });
    }

    useEffect(() => {
        validatePrice(getConvertedFabricData(fabricData), updatePrice)
    }, [fabricData.fabricBacking,
        fabricData.fkChainColourId,
        fabricData.fkMotorisationComponentId,
        fabricData.backingColour,
        fabricData.standardOrReverse,
        fabricData.cassetteId,
        fabricData.bracketId,
        fabricData.widthMeasurementsId,
        fabricData.leftOrRightCord,
        fabricData.motorised,
        fabricData.fabricId,
        fabricData.quantity
    ]);

    useEffect(() => setSubmitDisabled(Object.keys(errors).length > 0), [errors])

    useEffect(() => {
        const foundFabric = fabrics.find(fabric => fabric.fabricId === selectedFabric);
        if (foundFabric){                    
            setItemTitle(foundFabric.fullName);
            validatePrice(fabricData, updatePrice)
        }
    }, [selectedFabric]);

    useEffect(() => {
        fetchOptions()
        loadFabrics()
    }, []);

    return (
        <Loader isLoading={loading}>
            <form className="p-32 pb-54 bg3 measurements-change active-group sm-p-20">
                <div className="row">
                    <div className="col">
                        <div className="subtitle1 mb-16 sm-text-24 default-text">{title() + ' '}
                            {infoIcons && infoIcons.length > 0  && (
                                <span className="paragraph-info-icon-wrapper">                                        
                                    <InformationOverlay item={infoIcons.find(o => o.name === "Description")} />
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="col-auto ps-24">
                        <span
                            className="curtains-icon curtains-icon-close size-24 show-btn hide-btn"
                            onClick={() => close()}
                        ></span>
                    </div>
                </div>

                { item.supplyOwnFabric && <SupplyOwnFabric fabricData={fabricData} errors={errors} handleInputChange={handleInputChange} onBlur={() => validatePrice(fabricData, updatePrice)} /> }
                { !item.supplyOwnFabric && <OtherFabricSelector fabrics={fabrics} totalFabricsCount={totalFabricsCount} loadAllFabrics={loadAllFabrics} selectedFabric={selectedFabric} setSelectedFabric={setSelectedFabric} /> }

                {/* Measurements */}
                <div>
                    <div className='row'>
                        <div className="col">
                            <div className="body-text3 gray mb-8">Measurements:</div>
                        </div>
                        <div className='col-auto'>
                            {infoIcons && infoIcons.length > 0  && (
                                <InformationOverlay item={infoIcons.find(o => o.name === "HowToMeasure")} clickTitle="How to Measure?" />
                            )}
                        </div>                            
                    </div>

                    <div className="row d-flex gap-40 sm-gap-16 mb-16">
                        <div className="col">
                            <div className="body-text3 mb-8">Width</div>
                            <NumberInput
                                name="width"
                                value={fabricData.width}
                                onChange={handleInputChange}
                                decimals={1}
                                onBlur={() => validatePrice(fabricData, updatePrice)}
                            />
                            {errors.Width && (
                                <span className="field-validation-error">{errors.Width}</span>
                            )}
                        </div>
                        <div className="col">
                            <div className="body-text3 mb-8">Height</div>
                            <NumberInput
                                name="height"
                                value={fabricData.height}
                                onChange={handleInputChange}
                                decimals={1}
                                onBlur={() => validatePrice(fabricData, updatePrice)}
                            />
                            {errors.Height && (
                                <span className="field-validation-error">{errors.Height}</span>
                            )}
                        </div>
                    </div>

                    <UnitConverter />
                </div>
                <div className="dashed-line mt-16"></div>

                {/* Width Measurement */}
                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Width Measurement:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "WidthMeasurement")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 nowrap-labels mb-16">
                        {widthMeasurements && widthMeasurements.length > 0 && widthMeasurements.map((option) => (
                            option && (
                                <RadioButton
                                    key={'widthMeasurementsId'+option.id}
                                    name="widthMeasurementsId"
                                    label={option.name}
                                    value={option.id}
                                    checked={fabricData.widthMeasurementsId == option.id}
                                    onChange={handleInputChange}
                            />
                            )
                        ))}
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Standard or Reverse Roll */}
                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Standard or Reverse Roll:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "StandardReverseRoll")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16">
                        <RadioButton
                            name="standardOrReverse"
                            label={'Standard'}
                            value={0}
                            checked={fabricData.standardOrReverse == 0}
                            onChange={handleInputChange}
                        />
                        <RadioButton
                            name="standardOrReverse"
                            label={'Reverse'}
                            value={1}
                            checked={fabricData.standardOrReverse == 1}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Fabric Backing */}
                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Fabric Backing:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "FabricBacking")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 nowrap-labels mb-16">
                        {fabricBackings && fabricBackings.length > 0 && fabricBackings.map((option) => (
                            option && (
                                <RadioButton
                                    key={'fabricBacking'+option.id}
                                    name="fabricBacking"
                                    label={option.name}
                                    value={option.id}
                                    checked={fabricData.fabricBacking == option.id}
                                    onChange={handleInputChange}
                            />
                            )
                        ))}
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Backing Colour */}
                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Backing Colour:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "BackingColour")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16">
                        <RadioButton
                            name="backingColour"
                            label={'Cream'}
                            value={0}
                            checked={fabricData.backingColour == 0}
                            onChange={handleInputChange}
                        />
                        <RadioButton
                            name="backingColour"
                            label={'White'}
                            value={1}
                            checked={fabricData.backingColour == 1}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Chain Color */}
                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Chain Colour:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "ChainColour")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 flex-wrap row-gap-16 mb-16 max-width-500 nowrap-labels">
                        {chainColours && chainColours.length > 0 && chainColours.map((option) => (
                            option && (
                                <RadioButton
                                    key={'fkChainColourId'+option.id}
                                    name="fkChainColourId"
                                    label={option.name}
                                    value={option.id}
                                    checked={fabricData.fkChainColourId == option.id}
                                    onChange={handleInputChange}
                            />
                            )
                        ))}
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Chain Position */}
                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Chain Position:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "ChainPosition")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16">
                        <RadioButton
                            name="leftOrRightCord"
                            label={'Left'}
                            value={1}
                            checked={fabricData.leftOrRightCord == 1}
                            onChange={handleInputChange}
                        />
                        <RadioButton
                            name="leftOrRightCord"
                            label={'Right'}
                            value={0}
                            checked={fabricData.leftOrRightCord == 0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Brackets */}
                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Fixing Brackets:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "Brackets")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 flex-wrap row-gap-16 mb-16 max-width-500 nowrap-labels">
                        {brackets && brackets.length > 0 && brackets.map((option) => (
                            option && (
                                <RadioButton
                                    key={'bracketId'+option.id}
                                    name="bracketId"
                                    label={option.name}
                                    value={option.id}
                                    checked={fabricData.bracketId == option.id}
                                    onChange={handleInputChange}
                            />
                            )
                        ))}
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Cassette */}
                {
                    <div>
                        <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Pelmet:
                            {infoIcons && infoIcons.length > 0  && (
                                <InformationOverlay item={infoIcons.find(o => o.name === "Cassette")} />
                            )}
                        </div>
                        {
                            fabricData.widthMeasurementsId == '1' ?
                                <div className="d-flex gap-32 flex-wrap row-gap-16 mb-16 max-width-500 nowrap-labels">
                                    {recessedCassette && recessedCassette.length > 0 && recessedCassette.map((option) => (
                                        option && (
                                            <RadioButton
                                                key={'cassetteId'+option.id}
                                                name="cassetteId"
                                                label={option.name}
                                                value={option.id}
                                                checked={fabricData.cassetteId == option.id}
                                                onChange={handleInputChange}
                                        />
                                        )
                                    ))}
                                </div> :
                                <div className="d-flex gap-32 flex-wrap row-gap-16 mb-16 max-width-500 nowrap-labels">
                                    {actualCassette && actualCassette.length > 0 && actualCassette.map((option) => (
                                        option && (
                                            <RadioButton
                                                key={'cassetteId'+option.id}
                                                name="cassetteId"
                                                label={option.name}
                                                value={option.id}
                                                checked={fabricData.cassetteId == option.id}
                                                onChange={handleInputChange}
                                            />
                                        )
                                    ))}
                                </div>
                        }
                        {
                        errors.Cassette
                            ? <span className="field-validation-error">{errors.Cassette}</span>
                            :<></>
                        }
                    </div>
                }
                <div className="dashed-line"></div>

                {/* Motorised */}
                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Motorised:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "Motorised")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16">
                        <RadioButton
                            name="motorised"
                            label={'Yes'}
                            value={1}
                            checked={fabricData.motorised == 1}
                            onChange={handleInputChange}
                        />
                        <RadioButton
                            name="motorised"
                            label={'No'}
                            value={0}
                            checked={fabricData.motorised == 0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="dashed-line"></div>

                {/* Control Unit */}
                {
                    fabricData.motorised == true &&
                    <div>
                        <div>
                            <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Control Unit:
                                {infoIcons && infoIcons.length > 0  && (
                                    <InformationOverlay item={infoIcons.find(o => o.name === "ControlUnit")} />
                                )}
                            </div>
                            <div className="d-flex gap-32 mb-16 flex-wrap row-gap-16 nowrap-labels">
                                {controlUnits && controlUnits.length > 0 && controlUnits.map((option) => (
                                    option && (
                                        <RadioButton
                                            key={'fkMotorisationComponentId'+option.id}
                                            name="fkMotorisationComponentId"
                                            label={option.name}
                                            value={option.id}
                                            checked={fabricData.fkMotorisationComponentId == option.id}
                                            onChange={handleInputChange}
                                    />
                                    )
                                ))}
                            </div>
                        </div>
                        <div className="dashed-line"></div>
                    </div>
                }

                {/* Installation Height */}
                {
                    fabricData.motorised == false && 
                        <div className="row d-flex gap-40 sm-gap-16">
                            <div className="col col-5">
                                <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Installation Height:
                                    {infoIcons && infoIcons.length > 0  && (
                                        <InformationOverlay item={infoIcons.find(o => o.name === "InstallationHeight")} />
                                    )}
                                </div>
                                <NumberInput
                                    name="installationHeight"
                                    value={fabricData.installationHeight}
                                    onChange={handleInputChange}
                                    decimals={0}
                                    onBlur={() => validatePrice(fabricData, updatePrice)}
                                />
                                {errors.InstallationHeight ? (
                                    <span className="field-validation-error">{errors.InstallationHeight}</span>
                                ) : null}
                            </div>
                        </div>
                }

                {/* Customization */}
                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Roller Blind Customisation:</div>
                    <div className="max-width-410 mb-16 sm-text-14">If you have special requests, write below or <a href="/contact-us" className="underline">contact us</a> <a href="tel:0345 8620743" className="underline">0345 8620743</a>.</div>
                    <TextBox
                        name="customisationRequests"
                        value={fabricData.customisationRequests}
                        onChange={handleInputChange}
                        placeholder='e.g. Trim or borders'
                        onBlur={() => validatePrice(fabricData, updatePrice)}
                    />
                    {errors.CustomisationRequests && (
                        <span className="field-validation-error">{errors.CustomisationRequests}</span>
                    )}
                </div>
                <div className="dashed-line mt-16"></div>

                {/* Window Location */}
                <div style={{marginBottom: '16px'}}>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Window Location:</div>
                    <div className="max-width-410 mb-16 sm-text-14">Let us know where you will be hanging your roller blinds, and we will include this in your order details.</div>
                    <TextBox
                        name="windowLocation"
                        value={fabricData.windowLocation}
                        onChange={handleInputChange}
                        placeholder='e.g. Living room front window'
                        onBlur={() => validatePrice(fabricData, updatePrice)}
                    />
                    {errors.WindowLocation && (
                        <span className="field-validation-error">{errors.WindowLocation}</span>
                    )}
                </div>

                {
                    item.supplyOwnFabric && 
                        <div>
                            <div className="body-text3 gray mt-32 mb-8 align-center gap_3">Quantity of fabric per item to be supplied by you:</div>
                            <TextBox name='sof-fabric-length' value={metres} className='max-width-150 mb-16' />
                        </div>
                }

                <Checkbox 
                    checked={measurementsChecked} 
                    label={'I have checked all measurements'}
                    value={!measurementsChecked}
                    onChange={handlerMeasurementCheck}
                    requiredMessage={''}
                    name={'measurementsChecked'} />
                { showMeasurementsCheckError && <div className="text-danger m-8">Please confirm you have checked everything.</div> }

                <div className="dashed-line mt-16"></div>

                {/* TOTAL */}
                <div>
                    <div className="subtitle2 mb-8 mt-16">TOTAL: <span className="body-text1">{formatCurrency(price, 2)}</span></div>
                    <div className="body-text6">Delivery for made-to-measure roller blinds: {item.deliveryContent} weeks.</div>
                </div>

                <div className="mb-16 mt-32">
                    <div className="dashed-line mb-24"></div>
                    <div className="body-text3 gray mb-16">Quantity:</div>
                    
                    <ProductQtyInput 
                        digits={0}
                        initValue={fabricData.quantity} 
                        onlyInt={true} 
                        onChange={handleQuantityChange} 
                        onBlur={() => validatePrice(fabricData, updatePrice)}
                    />
                    {errors.Quantity && (
                        <span className="field-validation-error">{errors.Quantity}</span>
                    )}
                </div>

                <div className="d-flex gap-16 mb-16 sm-column md-column sm-gap-8 sm-mb-0">
                    <div className="w-100 show-btn hide-btn">
                        <Button name="UPDATE" onClick={handleUpdate} disabled={isSubmitDisabled || Object.keys(errors).length > 0} />
                    </div>
                </div>
            </form>
        </Loader>
    );
}